export default __webpack_public_path__ + "static/media/brand-circle.c5259476.svg";